<template>
  <div>
    <Table
      :tableProp="tableProp"
      :tableData="tableData"
      :isOrderNo="true"
      :isSection="false"
      :orderWidth="80"
      :page="page"
    >
    </Table>

    <Pagination
        :page="page"
        v-if="tableData.length > 0"
        @setcurrentpage="setpage"
      ></Pagination>
  </div>
</template>

<script>
import utif from "@/utif/utif.js";
export default {
  data() {
    return {
      tableProp: [
        {
          code: "voucherId",
          label: "迪链号(母)",
          minWidth:180
        },
        {
          code: "issuer_name",
          label: "签发企业名称",
          minWidth:180
        },
        {
          code: "holder_name",
          label: "持有机构(持有人)名称",
          minWidth:180
        },
        {
          code: "amount",
          label: "签发金额",
          minWidth:150
        },
        {
          code: "currency",
          label: "币种",
          minWidth:100
        },        
        {
          code: "consultancyFee",
          label: "信息费",
          minWidth:150
        },
        {
          code: "serviceFee",
          label: "平台服务费",
          minWidth:150
        },
        {
          code: "transferFee",
          label: "转让费",
          minWidth:150
        },       
        {
          code: "settleStatus",
          label: "清分状态(是否)",
          minWidth:120,
        },
        {
          code: "issueDate",
          label: "签发日期",
          minWidth:150,
        },
        {
          code: "dueDate",
          label: "到期日期",
          minWidth:150
        },
        {
          code: "settleDate",
          label: "实际清分日期",
          minWidth:150
        },
        {
          code: "billDate",
          label: "账单生成日期",
          minWidth:150
        },
      ],
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        size: "10",
      },
      params: {},
    };
  },
  created() {
    this.getDataList()
  },
  methods: {
    setpage(val) {
      this.page.currentPage = val;
      this.getDataList(this.params);
    },
    getDataList(params = {}) {
      this.params = params;
      
      const par = {
        filterData: {
          ...params,
          reconciliationSubject:this.$route.query.reconciliationSubject,
          eventCode:this.$route.query.eventCode,
          reconciliationStatus:this.$route.query.reconciliationStatus,
          reconciliationEndDate:this.$route.query.reconciliationEndDate,
          reconciliationStartDate:this.$route.query.reconciliationStartDate
        },
        pageData: {
          page: this.page.currentPage + "",
          pageSize: this.page.size,
        },
      };
      this.$POST("/ac/reconciliations/detail", par).then((res) => {
        if (res.ret == "0" && res.data.content) {
          this.tableData = res.data.content;
          
          this.page.total = res.data.totalElements;
          this.tableData.forEach((item) => {
            item.amount = utif.moneyFLoatFormat(item.amount);
            item.consultancyFee = utif.moneyFLoatFormat(item.consultancyFee);
            item.serviceFee = utif.moneyFLoatFormat(item.serviceFee);
            item.transferFee = utif.moneyFLoatFormat(item.transferFee);
            item.issueDate = utif.cliceTime(item.issueDate);
            item.dueDate = utif.cliceTime(item.dueDate);
            item.settleDate = utif.cliceTime(item.settleDate);
            item.billDate = utif.cliceTime(item.billDate);
            item.settleStatus = item.settleStatus == 'S' ? '是' : '否'
          });
        } else {
          this.tableData = [];
          this.page = {
            total: 0,
            size: "10",
            currentPage: 1,
          };
        }
      });
    },
  },
};
</script>

<style>

</style>